import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1 className="about-title">About Lisa Halliwell, RCIC | Canadian Umbrella Immigration Services</h1>
          <p className="about-subtitle">Licensed Immigration Consultant in Charlottetown, PE</p>
        </div>
      </section>

      {/* Story Section */}
      <section className="story-section">
        <div className="container">
          <div className="story-content">
            <div className="story-intro">
              <h2>Our Story</h2>
              <p className="story-lead">
                At Canadian Umbrella Immigration Services Inc., we know that immigrating to Canada can feel overwhelming. 
                The process is filled with complex regulations, detailed procedures, and countless forms — but you don't have to face it alone. 
                We're here to guide you every step of the way.
              </p>
            </div>
            
            <div className="story-timeline">
              <div className="timeline-item">
                <div className="timeline-marker">
                  <div className="marker-icon">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                    </svg>
                  </div>
                </div>
                <div className="timeline-content">
                  <h3>Our Mission</h3>
                  <p>
                    Our mission is to provide professional, transparent, and supportive immigration services that help individuals and families navigate their journey to Canada with confidence.
                    We're committed to offering clear guidance, open communication, and unwavering support throughout your entire application process.
                  </p>
                </div>
              </div>

              <div className="timeline-item">
                <div className="timeline-marker">
                  <div className="marker-icon">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                    </svg>
                  </div>
                </div>
                <div className="timeline-content">
                  <h3>Meet Lisa Halliwell, RCIC</h3>
                  <p>
                    Lisa Halliwell is a Regulated Canadian Immigration Consultant (RCIC), a licensed and a proud member of the Canadian Association of Professional Immigration Consultants (CAPIC). 
                    She holds a Graduate Diploma in Immigration and Citizenship Law from Queen's University.
                  </p>
                  <p>
                    As the founder of Canadian Umbrella Immigration Services Inc., Lisa's goal is to help newcomers confidently navigate Canada's complex immigration system. 
                    With over 20 years of experience working for Canadian Members of Parliament, she has developed a deep understanding of immigration policies and the challenges applicants face. 
                    She has witnessed first-hand the common obstacles and mistakes that can delay or even derail applications — and is passionate about helping clients avoid them.
                  </p>
                </div>
              </div>

              <div className="timeline-item">
                <div className="timeline-marker">
                  <div className="marker-icon">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                  </div>
                </div>
                <div className="timeline-content">
                  <h3>Our Vision</h3>
                  <p>
                    At Canadian Umbrella Immigration Services Inc., Lisa brings her expertise, integrity, and personal commitment to every case. 
                    Whether you're applying for temporary residence, permanent residency, or Canadian citizenship, she provides honest, personalized, and results-driven guidance.
                    If you've already submitted an application and need help addressing complications or delays, Lisa can step in to help you find solutions and get your immigration journey back on track.
                  </p>
                </div>
              </div>
            </div>

            <div className="credentials-section">
              <h3>Professional Credentials</h3>
              <div className="credentials-grid">
                <div className="credential-card">
                  <div className="credential-icon">
                    <img src="/RCICIRB-removebg-preview.png" alt="RCIC-IRB Logo" />
                  </div>
                  <h4>Licensed RCIC</h4>
                  <p>Regulated Canadian Immigration Consultant</p>
                </div>
                <div className="credential-card">
                  <div className="credential-icon">
                    <img src="/CAPICnew.png" alt="CAPIC Logo" />
                  </div>
                  <h4>CAPIC Member</h4>
                  <p>Member of Canadian Association of Professional Immigration Consultants</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <h2 className="section-title">Our Core Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              </div>
              <h3>Integrity</h3>
              <p>We conduct our business with ethical standards, ensuring transparency and honesty in all our dealings.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                </svg>
              </div>
              <h3>Professionalism</h3>
              <p>We maintain high standards of service and expertise in all aspects of our work.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z"/>
                </svg>
              </div>
              <h3>Dedication</h3>
              <p>We are committed to helping our clients achieve their immigration goals through dedicated support.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.54 8H16c-.8 0-1.54.37-2.01 1l-3.99 5.33V22h-2v-8.67L8.01 9A2.01 2.01 0 0 0 6.01 8H3.46c-.8 0-1.54.37-2.01 1L1.5 15.37A1.5 1.5 0 0 0 3.46 18H6v6h2v-8.67L12 9l4 5.33V22h2z"/>
                </svg>
              </div>
              <h3>Excellence</h3>
              <p>We strive for excellence in every aspect of our service delivery and client support.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Journey?</h2>
            <p>Contact us to discuss your immigration options and learn how we can assist you.</p>
            <Link to="/book-consultation" className="btn btn-primary btn-large">
              Book Consultation
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 